import React, { useState, useEffect } from 'react';
import Slider from '@mui/material/Slider';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import './Likert3SidesResponse.scss'

function Likert3SidesResponse(props) {
    const neutralPortion = props.answer[1].percent 
    const scale = props.answer[0].percent + props.answer[1].percent + props.answer[2].percent
    const totalPercents = scale + props.answer[3].percent
    const sliderWidthPercentage = 100 * scale / totalPercents
    const thumbWidthPercentage = neutralPortion / scale * totalPercents
    const greyRecWidthPercentage = 100 - sliderWidthPercentage

    const sliderStyle = {
        '& input[type="range"]': {
            WebkitAppearance: 'slider-vertical',
        },
        width: '100%',
        height: 100,
        margin: 0,
        '& .MuiSlider-track': {
            border: 'none',
            borderRadius: 0,
            color: '#B2292D',
            opacity: props.responseSubmitted ? 0.38 : 1 
        },
        '& .MuiSlider-thumb': {
            height: 100,
            width: `${thumbWidthPercentage}%`,
            border: '4px solid black',
            backgroundColor: '#f4d06f',
            borderRadius: 0,
            marginLeft: `${thumbWidthPercentage/2}%`,
        },
        '& .MuiSlider-valueLabel': {
            backgroundColor: '#B2292D',
            border: '1px solid #E7DCDA'
        },
        '& .MuiSlider-valueLabelLabel': {
            fontSize: '14pt',
        },
        '& .MuiSlider-rail': {
            color: '#5B6586',
            opacity: props.responseSubmitted ? 0.38 : 1,
            borderRadius: 0,
        },
        '& .MuiSlider-markLabel': {
            margin: '80px 0',
            fontSize: '14pt',
        },
        '& .MuiSlider-mark': {
            opacity: 0,
            fontSize: '14pt',
        },
        justifyContent: 'center',
        display: 'flex',
        alignItems: 'center',
    }

    const marks = [];
    
    // only add values that are legible answers
    for (let i=0; i<=props.answer[0].percent + props.answer[2].percent; i++) {
        marks.push({
            value: i,
            label: ""
        })
    }

    const rectangleStyle = {
        height: 100,
        width: '100%',
        background: '#E7DCDA',
    }


    function handleChange(event) {
        props.setResponse([event.target.value, event.target.value + neutralPortion]);
        props.setDisplayTooltip(false);
    };

    function preventHorizontalKeyboardNavigation(event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
        }
    }

    function ariaLabel(value) {
        return `Range from ${value[0]} to ${value[1]}`
    }

    useEffect(() => {
        props.setResponse([Math.round((scale - neutralPortion)/2), Math.round((scale - neutralPortion)/2) + neutralPortion])
    }, [])

    return (
        <div className="likert-response-container">
            <Grid container direction="row" justifyContent="center" alignItems="center" pb='15px'>
                <Grid item width={`${sliderWidthPercentage}%`}>
                    <Slider
                        sx={sliderStyle}
                        orientation="horizontal"
                        getAriaLabel={ariaLabel}
                        onKeyDown={preventHorizontalKeyboardNavigation}
                        onChange={handleChange}
                        valueLabelDisplay={(props.displayTooltip) ? "on" : "off"}
                        valueLabelFormat="Slide"
                        max={scale}
                        marks={marks}
                        step={null}
                        disableSwap
                        defaultValue={Math.round((scale - neutralPortion)/2)}
                        disabled={props.responseSubmitted}
                    />
                </Grid>
                <Grid item width={`${greyRecWidthPercentage}%`} justifyContent='center' display='flex' alignItems='center'>
                    <Stack spacing={0} width="100%">
                        <div style={rectangleStyle}></div>     
                    </Stack>                    
                </Grid>
            </Grid>
        </div>
    );
}

export default Likert3SidesResponse;